import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutomationRulesComponent } from './component/automation-rules.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';

import { TableSelectionDialogModule } from 'src/tmc-common/components/table-selection-dialog/table-selection-dialog.module';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    TableSelectionDialogModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    AutomationRulesComponent
  ]
})
export class AutomationRulesModule { }

